import { Singleton } from 'framework/di';

@Singleton()
export class JQueryHelper {
  protected jqueryInstance: JQueryStatic | null = null;

  constructor() {
    this.load();
  }

  get jQuery(): JQueryStatic {
    if (!this.jqueryInstance) {
      throw new Error('jQuery instance has not been set.');
    }

    return this.jqueryInstance;
  }

  async load() {
    if (!this.jqueryInstance) {
      return import('jquery').then((module) => {
        this.jqueryInstance = module.default.noConflict(true);
        return this.jqueryInstance;
      });
    }

    return Promise.resolve(this.jqueryInstance);
  }

  onLoaded(callback: (jQuery: JQueryStatic) => void) {
    if (this.jqueryInstance) {
      callback(this.jqueryInstance);
    } else {
      this.load().then((jQuery) => {
        callback(jQuery);
      });
    }
  }
}
